import store from './store';
import {
  clearSession,
  setCurrentUser,
  setDeviceKey,
} from './appSlice';
import applyLanguagePreference from '../utils/applyLanguagePreference';

const getState = () => store.getState();

const ApiStorage = {
  getCurrentUser: () => getState().currentUser,
  setCurrentUser: (user) => {
    applyLanguagePreference(user?.language);
    store.dispatch(setCurrentUser(user));
  },
  clearUser: () => store.dispatch(setCurrentUser(null)),

  getDeviceKey: () => getState().deviceKey || '',
  setDeviceKey: (deviceKey) => store.dispatch(setDeviceKey(deviceKey || '')),

  clearSession: () => store.dispatch(clearSession()),
};

export default ApiStorage;
